import React, { useState, useEffect } from 'react'
import {Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import PdfViewer from '../PdfViewer';
import DocViewer from '../../DocViewer';
import VideoViewer from '../VideoViewer';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import './accordion.scss'

export default function ControlledAccordions(props) {

  const { data } = props
  const [expanded, setExpanded] = React.useState(false);
  const [keys, setKeys] = useState(null)
  const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
  };

  const writeValue = (value) => {

    const videFormat = ['.mp4', '.mkv', '.flv', '.wmv', '.avi', '.mp3', '.wma', '.wav', '.m4a', '.asf'];
    const docFormat = ['.doc', '.docx', '.txt', '.pdf', '.rtf'];

    if(typeof(value) === 'string') {
      if (docFormat.some(format => value.endsWith(format))) {          
          return <PdfViewer url={value}></PdfViewer>
      }

      if (videFormat.some(format => value.endsWith(format))) { 
        return <VideoViewer url={value}></VideoViewer>
      }
        
    }  
      
  } 

  useEffect(() => {
    const objKeys = Object.keys(data);
    setKeys(objKeys)
  }, [data])

  return (
    <>
    {
        keys !== null && (
          <div className='accordion-item'>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                  {data[keys[0]]}
              </AccordionSummary>
              <AccordionDetails>
                <div className='detail-content'>
                  {writeValue(data[keys[1]])}
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        )
      }
    </>

  );
}